



import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import HeaderLogo from "@/components/Atoms/HeaderLogo/HeaderLogo.vue";
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";
import MenuItem from "@/components/Atoms/MenuItem/MenuItem.vue";

@Component({
  components: {HeaderLogo, SvgRender, MenuItem}
})
export default class Sidebar extends Vue {
  @Prop({required: false, type: Boolean, default: false}) isShow?: boolean
  private visible = false

  @Watch('isShow', {immediate: true})
  private onIsShowChange(value: boolean): void {
    this.visible = value
  }

  private onClickHiddenSidebar(): void {
    this.$emit('hidden')
  }

  private get className():string {
    if (this.visible) return 'show'
    return ''
  }
}
